import { useId } from "react";

import { cn } from "@/lib/utils";

export function CitiesIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  const id = useId();

  return (
    <svg
      aria-hidden="true"
      className={cn("h-22.5 w-33.5", className)}
      fill="none"
      viewBox="0 0 134 90"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M2.666 59.867v-2.371L83.864 30.81l47.141 27.43-.001 2.361-81.197 29.056-47.141-29.79z"
        fill={`url(#${id}a)`}
      />
      <mask
        height="60"
        id={`${id}c`}
        maskUnits="userSpaceOnUse"
        style={{ maskType: "alpha" }}
        width="129"
        x="2"
        y="28"
      >
        <path
          d="M0 0h83.933v59.637H0z"
          fill={`url(#${id}b)`}
          transform="matrix(.96742 -.34619 .79046 .49954 2.61 57.43)"
        />
      </mask>
      <g mask={`url(#${id}c)`}>
        <path
          d="M0 0h83.933v59.637H0z"
          fill={`url(#${id}d)`}
          transform="matrix(.96742 -.34619 .79046 .49954 2.61 57.43)"
        />
        <path
          clipRule="evenodd"
          d="M31.246 75.526l-2.473-1.562L45.298 62.2 14.9 57.653a1.354 1.354 0 01.4-2.677l33.176 4.963 14.576-10.376a1.354 1.354 0 011.57 2.205l-12.289 8.748 21.415 3.204 6.95-9.734L60.13 43.782a1.354 1.354 0 01-1.591-.789l-6.531-3.24 3.539-1.266 4.41 2.188 10.151-7.399 5.994-2.145a1.356 1.356 0 01-.497 1.49L62.69 42.03l20.376 10.11 39.408.67 4.401 2.78-43.459-.75-6.662 9.33 25.972 3.886c.115.017.225.049.327.092l-5.31 1.9-22.755-3.404-11.075 15.51-4.461 1.596c.018-.03.037-.06.058-.088l5.363-7.511-24.847-6.873-8.78 6.25zm17.91-12.748l22.826 3.415-5.434 7.611-23.68-6.55 6.288-4.476z"
          fill="#fff"
          fillRule="evenodd"
          opacity="0.5"
        />
        <path
          d="M66.383 104.91l-24.02-34.625L84.65 43.878l59.235 21.857-77.502 39.175z"
          fill={`url(#${id}e)`}
          opacity="0.3"
        />
      </g>
      <path
        d="M108.877 59.447c.058 1.12-2.316 2.153-5.302 2.308-2.987.155-5.454-.627-5.513-1.746-.058-1.12 2.316-2.154 5.302-2.309 2.986-.155 5.454.627 5.513 1.747zM48.54 51.582c.059 1.12-2.315 2.153-5.301 2.308-2.986.155-5.454-.627-5.513-1.747-.058-1.12 2.316-2.153 5.302-2.308 2.986-.155 5.454.627 5.513 1.747zm6.81 26.182c.057 1.12-2.316 2.154-5.303 2.309-2.986.155-5.454-.627-5.512-1.747-.058-1.12 2.316-2.153 5.302-2.308 2.986-.156 5.454.626 5.512 1.746z"
        fill="#fff"
        opacity="0.23"
      />
      <path
        d="M23.2 57.078l33.67 19.92 44.452-17.29V33.612L64.43 14.237 23.2 29.14v27.938z"
        fill={`url(#${id}f)`}
      />
      <path
        d="M56.828 76.986V48.971L23.19 28.927V57.09l33.637 19.896z"
        fill={`url(#${id}g)`}
      />
      <path
        d="M52.19 73.033V54.542l-22.202-13.23-2.652 1.428 2.652 17.16 19.556 14.85 2.646-1.717z"
        fill="#ADEAFF"
      />
      <path
        d="M49.465 56.413l2.797-1.753v18.41l-2.797 1.703v-18.36z"
        fill="#4FAFD0"
      />
      <path
        d="M49.588 74.786V56.295l-22.201-13.23v18.589l22.201 13.132z"
        fill="#557AFF"
      />
      <path
        d="M92.268 36.752L61.684 47.41v27.757l2.793 1.063 27.79-12.976V36.751z"
        fill="#4FAFD0"
      />
      <path
        d="M95.088 37.692L64.504 48.35v27.758l30.584-11.913V37.692z"
        fill={`url(#${id}h)`}
      />
      <path
        clipRule="evenodd"
        d="M23.266 28.938L56.829 49.08l5.117-1.777 2.623 1.128 30.687-10.704-2.908-.985 8.981-3.12-36.898-19.525-41.165 14.84z"
        fill="#fff"
        fillRule="evenodd"
      />
      <path
        d="M27.066 29.255L56.915 47.17l4.55-1.58 2.332 1.002 27.292-9.52-2.587-.875 7.989-2.774-32.815-17.365-36.61 13.197z"
        fill="#586DFF"
      />
      <path
        d="M55.228 41.312l-15.814-9.434v-3.133l24.827-5.711 17.479 5.643v3.606l-26.492 9.029z"
        fill="#ADEAFF"
      />
      <path
        d="M55.227 37.713L39.414 28.65l24.827-8.844 17.478 8.878-26.492 9.03z"
        fill="#fff"
      />
      <path
        clipRule="evenodd"
        d="M69.636 16.409c0-5.34-3.751-11.833-8.369-14.502C58.766.46 56.497.433 54.944 1.56l-3.987 2.572c.454.135 1.152.41 2.024.846a9.485 9.485 0 00-.156 1.763c0 .499-.01 1.011-.022 1.534-.053 2.417-.11 5.057.906 7.674 2.086 5.373 6.037 10.43 7.181 11.895.163.208-.505 1.004-.47 1.057.775-.542 9.216-5.378 9.216-12.492zM57.841 8.105c-.3.45-.47 1.063-.47 1.81 0 2.453 1.731 5.412 3.824 6.638.634.372 1.234.538 1.764.523-.024-2.488-.666-4.932-2.468-6.666a34.96 34.96 0 00-2.65-2.305z"
        fill={`url(#${id}i)`}
        fillRule="evenodd"
      />
      <path
        d="M57.38 4.428c4.617 2.67 8.369 9.163 8.369 14.502 0 8.298-8.01 11.689-8.442 11.833-.433-.65-8.37-13.276-8.37-21.5 0-5.34 3.825-7.505 8.442-4.835zm-.073 14.647c2.092 1.226 3.824.216 3.824-2.165 0-2.38-1.732-5.411-3.824-6.638-2.092-1.226-3.824-.216-3.824 2.165 0 2.453 1.732 5.411 3.824 6.638z"
        fill={`url(#${id}j)`}
      />
      <path
        d="M55.29 37.633v3.68l26.533-9.087v-3.623l-26.534 9.03z"
        fill="#4FAFD0"
      />
      <path
        d="M72.336 53.18v-3.087l2.039-.693v.607l-1.332.452v.633l1.227-.417v.608l-1.227.417v.634l1.332-.452v.606l-2.04.692zm4.062-3.54c-.01-.108-.052-.18-.127-.215-.075-.037-.18-.032-.319.014a.812.812 0 00-.228.116.49.49 0 00-.137.15.343.343 0 00-.047.165.188.188 0 00.025.114c.02.028.049.05.086.064a.483.483 0 00.137.023c.053.002.113 0 .18-.008l.251-.025c.145-.016.273-.015.383.003a.68.68 0 01.28.102c.076.05.133.119.172.205a.775.775 0 01.06.315 1.151 1.151 0 01-.14.55 1.44 1.44 0 01-.398.456c-.172.132-.38.24-.624.323a1.596 1.596 0 01-.64.1.586.586 0 01-.423-.208c-.101-.123-.153-.305-.156-.546l.677-.23c.005.098.03.173.075.224a.27.27 0 00.185.088.672.672 0 00.274-.042.87.87 0 00.242-.123.58.58 0 00.156-.166.368.368 0 00.056-.185c-.001-.058-.018-.102-.052-.131a.259.259 0 00-.154-.057 1.307 1.307 0 00-.262.004l-.306.028c-.253.025-.453-.007-.598-.094-.146-.088-.218-.25-.217-.484-.001-.19.047-.375.145-.552a1.61 1.61 0 01.407-.474 1.92 1.92 0 01.593-.322c.226-.077.423-.103.59-.078a.582.582 0 01.39.207.72.72 0 01.14.459l-.676.23zm3.728-1.073l-.714.242a.517.517 0 00-.059-.19.31.31 0 00-.29-.162.63.63 0 00-.218.038.895.895 0 00-.367.235c-.102.108-.18.24-.236.398a1.623 1.623 0 00-.081.531c0 .205.028.368.083.488a.42.42 0 00.235.232.557.557 0 00.362-.019.901.901 0 00.382-.253.808.808 0 00.189-.414l.713-.238c-.012.141-.05.288-.112.442a1.961 1.961 0 01-.652.844c-.156.118-.334.21-.535.278-.264.09-.501.11-.71.058a.797.797 0 01-.495-.372c-.12-.195-.181-.462-.181-.801 0-.34.061-.649.184-.927.123-.277.289-.513.498-.707a1.95 1.95 0 01.704-.423c.177-.06.341-.09.491-.088.15 0 .283.03.397.091a.7.7 0 01.279.27c.071.119.115.268.133.447zm.962 1.643l-.76.257.987-3.422.94-.32.987 2.753-.76.258-.686-2.077-.023.008-.685 2.542zm-.102-1.181l1.588-.54v.568l-1.588.539v-.567zm2.571.342v-3.088l1.208-.41c.219-.074.408-.093.567-.056a.57.57 0 01.37.25c.086.13.13.301.13.513 0 .214-.045.415-.133.605a1.492 1.492 0 01-.376.497 1.692 1.692 0 01-.58.328l-.745.253v-.588l.614-.209a.769.769 0 00.267-.15.64.64 0 00.22-.487.412.412 0 00-.056-.228.238.238 0 00-.164-.107.539.539 0 00-.267.033l-.348.118v2.486l-.707.24zm2.623-.89v-3.088l2.038-.692v.606l-1.332.452v.634l1.228-.417v.608L86.886 47v.635l1.332-.452v.606l-2.038.692zm-12.04 9.182v-3.088l1.208-.41c.219-.074.408-.097.567-.067.16.028.283.105.37.23.086.124.13.292.13.503 0 .214-.045.411-.133.591a1.417 1.417 0 01-.377.469 1.844 1.844 0 01-.579.312l-.763.26v-.589l.632-.214a.96.96 0 00.267-.135.558.558 0 00.164-.191.559.559 0 00.056-.254.36.36 0 00-.056-.218.217.217 0 00-.164-.086.645.645 0 00-.267.042l-.348.119v2.486l-.707.24zm1.646-1.97l.728 1.164-.77.261-.715-1.168.757-.257zm3.776-1.414c0 .34-.062.648-.186.926a2.12 2.12 0 01-.502.71 1.97 1.97 0 01-.709.424c-.262.089-.499.107-.71.055a.813.813 0 01-.5-.368c-.123-.195-.184-.461-.184-.8 0-.34.06-.649.184-.926.124-.279.29-.515.5-.709.211-.194.448-.336.71-.425.262-.088.498-.107.709-.056.21.05.378.173.502.367.124.195.186.462.186.802zm-.723.245c0-.201-.027-.362-.081-.482a.41.41 0 00-.231-.237.534.534 0 00-.362.016.886.886 0 00-.36.23 1.04 1.04 0 00-.234.393c-.053.157-.08.336-.08.537s.027.362.08.483c.055.12.132.199.233.236a.535.535 0 00.361-.016.88.88 0 00.362-.23c.1-.105.178-.236.23-.393a1.64 1.64 0 00.082-.537zm3.895-1.322c0 .34-.062.648-.185.927a2.122 2.122 0 01-.503.708 1.97 1.97 0 01-.708.425c-.263.089-.5.107-.71.055a.812.812 0 01-.5-.368c-.124-.195-.185-.461-.185-.8 0-.34.061-.648.184-.926.124-.279.29-.515.501-.709.21-.194.447-.335.71-.425.262-.088.498-.107.708-.056.211.05.379.173.502.368.124.194.186.46.186.8zm-.722.245a1.19 1.19 0 00-.082-.482.411.411 0 00-.231-.237.534.534 0 00-.361.016.886.886 0 00-.361.23 1.047 1.047 0 00-.233.394c-.053.156-.08.335-.08.536s.026.362.08.483c.054.12.132.199.233.236.1.037.22.032.36-.016a.88.88 0 00.362-.23c.1-.105.178-.236.231-.393.054-.157.082-.336.082-.537zm1.135-1.929l.875-.297.742 1.66.035-.012.742-2.164.875-.297v3.088l-.688.233v-1.896l-.024.008L85 53.956l-.44.15-.702-1.65-.024.009v1.907l-.688.233v-3.087z"
        fill="#fff"
      />
      <path
        d="M77.894 61.272v9.599l7.857-3.22v-9.336l-7.857 2.957z"
        fill="#4E5DD3"
      />
      <path d="M81.82 59.95v9.286" stroke="#fff" strokeWidth="0.4" />
      <defs>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}a`}
          x1="127.676"
          x2="8.789"
          y1="55.013"
          y2="83.709"
        >
          <stop stopColor="#CEA8FF" />
          <stop offset="1" stopColor="#8F5DE0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}b`}
          x1="102.758"
          x2="37.363"
          y1="-8.18"
          y2="-54.301"
        >
          <stop stopColor="#AB7CE7" />
          <stop offset="1" stopColor="#6533B7" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}d`}
          x1="102.758"
          x2="37.363"
          y1="-8.18"
          y2="-54.301"
        >
          <stop stopColor="#AB7CE7" />
          <stop offset="1" stopColor="#6533B7" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}e`}
          x1="83.335"
          x2="132.283"
          y1="63.329"
          y2="119.734"
        >
          <stop stopColor="#0E0077" />
          <stop offset="1" stopColor="#0E0077" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}f`}
          x1="82.043"
          x2="9.392"
          y1="114.736"
          y2="94.78"
        >
          <stop stopColor="#586AFF" />
          <stop offset="1" stopColor="#43C9FF" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}g`}
          x1="62.768"
          x2="33.832"
          y1="95.775"
          y2="102.494"
        >
          <stop stopColor="#586AFF" />
          <stop offset="1" stopColor="#43C9FF" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}h`}
          x1="111.111"
          x2="54.158"
          y1="42.129"
          y2="70.366"
        >
          <stop stopColor="#4FAFD0" />
          <stop offset="1" stopColor="#557AFF" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}i`}
          x1="67.656"
          x2="45.365"
          y1="35.11"
          y2="30.067"
        >
          <stop stopColor="#E27CBC" />
          <stop offset="1" stopColor="#D494DE" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}j`}
          x1="65.749"
          x2="38.38"
          y1="41.598"
          y2="35.418"
        >
          <stop stopColor="#C1348C" />
          <stop offset="1" stopColor="#9432A4" />
        </linearGradient>
      </defs>
    </svg>
  );
}
